import React from 'react'

const BlogTag = () => {
    const arr = [
        {
          title:"آموزش میزبانی"
        },
        {
          title:"تجربه بوم گردی"
        },
        {
          title:"تهران گردی"
        },
        {
          title:"هتل داخلی"
        },
        {
          title:"سفرنامه"
        },
        {
          title:"گردشگری سلامت"
        },
        {
          title:"آیین ها م مراسمات"
        },
       
      ]
  return (
    <div className='BlogSidebar-box mt-[50px]'>
    <h2>تگ های محبوب</h2>
    <div className='BlogTag mt-[20px]'>
      {
          arr.map(i=><div className='BlogTag_tag text-center'>
              {i.title}
          </div>)
      }
    </div>
    </div>
  )
}

export default BlogTag